import { gql } from "@apollo/client";

// Components
import Head from "next/head";
import Header from "@/components-layout/header/header";
import Footer from "@/components-layout/footer/footer";
import Container from "@/components-layout/container/container";
import EntryHeader from "@/components/entry-header/entry-header";

// Constants
import { genSetVars, imgFields } from "@/constants/gql-fields";
import PostsContainer from "@/components-posts/posts-container/posts-container";

export default function Component(props) {
  // Variables
  const data = props.data;
  const siteTitle = data.generalSettings.title;
  const { archiveType, name } = data.nodeByUri;
  let isPostArc = false;
  let nodeData = ""; // Name of nodeByUri object to dynamically set data
  let postType = "";
  let label = "";

  let gqlName = ""; // TODO: TEMP - replace with dyncamic var after changing post group names (MAYBE - CHECK post vs events)

  if (archiveType === "ContentType") {
    postType = name;
    nodeData = "contentNodes";
    isPostArc = true;
    label = data.nodeByUri.label;
    gqlName = "post";
  } else if (archiveType === "Category" || archiveType === "Tag") {
    postType = nodeData = "posts";
    gqlName = "post";
  }
  // else if (archiveType === "EventType") {
  //   postType = nodeData = "events";
  //   gqlName = "event";
  // }

  const postData = data.nodeByUri[nodeData];
  const postSettings =
    data.postTypeSettingsOptionsPage.posttypeSettingsACF[gqlName + "Group"];
  //     data.postTypeSettingsOptionsPage.posttypeSettingsACF[postType + "Group"];

  return (
    <>
      <Head>
        {isPostArc ? (
          <title>{`Archive: ${label} - ${siteTitle}`}</title>
        ) : (
          <title>{`${archiveType}: ${name} - ${siteTitle}`}</title>
        )}

        {/* <title>{data.page.seo.title}</title> */}
        {/* <meta name="description" content={data.page.seo.metaDesc} /> */}
      </Head>

      <Header entry={data.generalSettingsOptionsPage.generalSettingsACF} />

      <main>
        {isPostArc ? (
          <EntryHeader title={`Archive for ${label}`} />
        ) : (
          <EntryHeader title={`Archive for ${archiveType}: ${name}`} />
        )}

        <section className={postType}>
          <Container>
            {isPostArc ? (
              <h2>View all {label}</h2>
            ) : (
              <h2>
                Recent {name} {postType}
              </h2>
            )}
            <PostsContainer
              posts={postData.nodes}
              postSettings={postSettings}
              postType={postType}
              parent={"taxonomy"}
            />
          </Container>
        </section>
      </main>

      <Footer entry={data.generalSettingsOptionsPage.generalSettingsACF} />
    </>
  );
}

// TODO: Figure out how to conditonally query posttype group in archive
Component.variables = (seedQuery, ctx) => {
  return {
    uri: seedQuery.uri,
  };
};

Component.query = gql`
  query GetArchive($uri: String!) {
    # -- Site Settings
    generalSettings {
      title
    }

    nodeByUri(uri: $uri) {
      archiveType: __typename
      ... on ContentType {
        name
        label
        contentNodes {
          nodes {
            id
            uri
            date
            ... on NodeWithTitle {
              title
            }
            ... on NodeWithFeaturedImage {
              featuredImage { 
                ${imgFields}
              }
            }
            ... on NodeWithExcerpt {
              excerpt
            }
            ... on NodeWithAuthor {
              author {
                node {
                  name
                  url
                  uri
                }
              }
            }
          }
        }
      }
      ... on Category {
        name
        posts {
          nodes {
            id
            title
            excerpt
            uri
            date
            featuredImage { 
              ${imgFields}
            }
            author {
              node {
                name
                url
                uri
              }
            }
          }
        }
      }
      ... on Tag {
        name
        posts {
          nodes {
            id
            title
            date
            uri
            featuredImage { 
              ${imgFields}
            }
            author {
              node {
                name
                url
                uri
              }
            }
            excerpt
          }
        }
      }
    }

    # -- Header
    ...HeaderFragment @unmask(mode: "migrate")

    # -- Footer Fragment
    ...FooterFragment @unmask(mode: "migrate")

    # -- General Settings Variables
    ${genSetVars}

    postTypeSettingsOptionsPage {
      id
      __typename
      posttypeSettingsACF {
        id
        __typename
        postGroup {
          id
          __typename
          modulesPostStyle
          ...PostGroupFragment @unmask(mode: "migrate")
        }
      }
    }
  }
  ${Header.fragments.entry}
  ${Footer.fragments.entry}
  ${PostsContainer.fragments.posts}
`;
